import { collectTrackData } from '@/utils/Tracker/tracker';

const EVENT = {
  NAME: 'gaEvent',
  CHAT: {
    CAMPAIGN: 'Fluxo de Chat',
    ACTION: {
      SUPPORT: 'Clique no botão "Suporte"',
      START_CONVERSATION: 'Clique no botão "Iniciar conversa"',
      CATEGORY_SERVICES: 'Categoria - Serviços mais frequentes',
      CATEGORY_HOSTING: 'Categoria - Hospedagem',
      CATEGORY_DOMAIN: 'Categoria - Domínio',
      CATEGORY_EMAIL: 'Categoria - E-mail',
      CATEGORY_SITE_OFFLINE: 'Categoria - Site fora do ar',
      CATEGORY_NOT_FOUND: 'Categoria - Não encontrei o que procurava',
      CATEGORY_FINANCIAL: 'Categoria - Pagamentos, Faturas e Assinaturas',
      CATEGORY_BUILDER_TOOLS: 'Categoria - WordPress e outros Criadores de sites',
      AGREE_SERVICES: 'Li e concordo -  Serviços frequentes',
      AGREE_HOSTING: 'Li e concordo -  hospedagem',
      AGREE_DOMAIN: 'Li e concordo - domínio',
      AGREE_EMAIL: 'Li e concordo email',
      AGREE_SITE_OFFLINE: 'Li e concordo site fora do ar',
      AGREE_NOT_FOUND: 'Li e concordo não encontrei',
      AGREE_FINANCIAL: 'Li e concordo Pagamentos, Faturas e Assinaturas',
      AGREE_BUILDER_TOOLS: 'Li e concordo ir para conversa/WordPress e outros Criadores de sites',
    },
    LABEL: {
      SUPPORT: 'clique_botao_suporte',
      START_CONVERSATION: 'clique_card_iniciar_conversa',
      CATEGORY_SERVICES: 'selecionar_categoria_servicos_frequentes',
      CATEGORY_HOSTING: 'selecionar_categoria_hospedagem',
      CATEGORY_DOMAIN: 'selecionar_categoria_dominio',
      CATEGORY_EMAIL: 'selecionar_categoria_email',
      CATEGORY_SITE_OFFLINE: 'selecionar_categoria_site_fora_do_ar',
      CATEGORY_NOT_FOUND: 'selecionar_categoria_nao_encontrei',
      CATEGORY_FINANCIAL: 'selecionar_categoria_chat_pagamentos_faturas_assinaturas',
      CATEGORY_BUILDER_TOOLS: 'selecionar_categoria_chat_wordpress_criadores_de_sites',
      AGREE_SERVICES: 'selecionar_categoria_servicos_frequentes',
      AGREE_HOSTING: 'selecionar_categoria_hospedagem',
      AGREE_DOMAIN: 'selecionar_categoria_dominio',
      AGREE_EMAIL: 'selecionar_categoria_email',
      AGREE_SITE_OFFLINE: 'selecionar_categoria_site_fora_do_ar',
      AGREE_NOT_FOUND: 'selecionar_categoria_nao_encontre',
      AGREE_FINANCIAL: 'li_e_concordo_ir_para_conversa_pagamentos_faturas_assinaturas',
      AGREE_BUILDER_TOOLS: 'li_e_concordo_ir_para_conversa_wordpress_criadores_de_sites',
    },
  },
  SUPPORT: {
    CAMPAIGN: 'Fluxo de Chamado',
    ACTION: {
      SUPPORT: 'Clique no botão "Suporte"',
      SEE_TICKET: 'Clique no botão "Ver chamados"',
      START_CONVERSATION: 'Clique no botão "Novo chamado"',
      CATEGORY_SERVICES: 'Categoria - Serviços mais frequentes',
      CATEGORY_HOSTING: 'Categoria - Hospedagem',
      CATEGORY_DOMAIN: 'Categoria - Domínio',
      CATEGORY_EMAIL: 'Categoria - E-mail',
      CATEGORY_SITE_OFFLINE: 'Categoria - Site fora do ar',
      CATEGORY_NOT_FOUND: 'Categoria - Financeiro',
      CATEGORY_FINANCIAL: 'Categoria - Não encontrei o que procurava',
      AGREE_SERVICES: 'Botão - Enviar Solicitação',
      AGREE_HOSTING: 'Botão - Enviar Solicitação',
      AGREE_DOMAIN: 'Botão - Enviar Solicitação',
      AGREE_EMAIL: 'Botão - Enviar Solicitação',
      AGREE_SITE_OFFLINE: 'Botão - Enviar Solicitação',
      AGREE_NOT_FOUND: 'Botão - Enviar Solicitaçã',
      AGREE_FINANCIAL: 'Botão - Enviar Solicitação',
    },
    LABEL: {
      SUPPORT: 'clique_botao_suporte',
      SEE_TICKET: 'clique_botao_ver_chamadosclique_botao_ver_chamados',
      START_CONVERSATION: 'clique_botao_novo-chamado',
      CATEGORY_SERVICES: 'clique_botao_ver_chamados',
      CATEGORY_HOSTING: 'selecionar_categoria_formulario_servicos_frequentes',
      CATEGORY_DOMAIN: 'selecionar_categoria_formulario_hospedagem',
      CATEGORY_EMAIL: 'selecionar_categoria_formulario_dominio',
      CATEGORY_SITE_OFFLINE: 'selecionar_categoria_formulario_email',
      CATEGORY_NOT_FOUND: 'selecionar_categoria_formulario_site_fora_do_ar',
      CATEGORY_FINANCIAL: 'selecionar_categoria_formulario_financeiro',
      AGREE_SERVICES: 'selecionar_categoria_formulario_nao_encontrei',
      AGREE_HOSTING: 'clique_botao_enviar_solicitacao_hospedagem',
      AGREE_DOMAIN: 'clique_botao_enviar_solicitacao_dominio',
      AGREE_EMAIL: 'clique_botao_enviar_solicitacao_email',
      AGREE_SITE_OFFLINE: 'clique_botao_enviar_solicitacao_site_fora_do_ar',
      AGREE_NOT_FOUND: 'clique_botao_enviar_solicitacao_nao_encontre',
      AGREE_FINANCIAL: 'clique_botao_enviar_solicitacao_financeiro',
    },
  },
  AUTO: {
    CAMPAIGN: 'Fluxo do AutoAtendimento',
    ACTION: {
      CATEGORY_DOMAIN_EPP: 'Categoria Domínios - Chave EPP',
      CATEGORY_DOMAIN_CONFIGURE: 'Categoria Domínios - Configurar Domínio',
      CATEGORY_SITEOFFLINE_REACTIVATE: 'Categoria Site fora do ar - Reativar Plano',
      CATEGORY_WEBSITEBUILDER_ACTIVATE: 'Categoria Criadores de Sites - Ativar Criador de Sites',
      CATEGORY_WEBSITEBUILDER_INSTALLWP: 'Categoria Criadores de Sites - Instalar WordPress',
      CATEGORY_PAYMENTS_CHANGE_CYCLE: 'Categoria Pagamentos - Alterar Ciclo de Pagamento',
      CATEGORY_PAYMENTS_CHANGE_PLAN: 'Categoria Pagamentos - Alterar Plano de Hospedagem',
      CATEGORY_PAYMENTS_CHANGE_METHOD: 'Categoria Pagamentos - Alterar Método de Pagamento',
      CATEGORY_PAYMENTS_REACTIVATE: 'Categoria Pagamentos - Reativar Plano',
      CATEGORY_PAYMENTS_CANCEL_SUB: 'Categoria Pagamentos - Cancelar Assinatura',
    },
    LABEL: {
      CATEGORY_DOMAIN_EPP: 'autoatendimento_chave_EPP_solicitar',
      CATEGORY_DOMAIN_CONFIGURE: 'autoatendimento_configurar_dominio',
      CATEGORY_SITEOFFLINE_REACTIVATE: 'autoatendimento_reativar_plano',
      CATEGORY_WEBSITEBUILDER_ACTIVATE: 'autoatendimento_ativar_criador_de_sites',
      CATEGORY_WEBSITEBUILDER_INSTALLWP: 'autoatendimento_instalar_wordpress',
      CATEGORY_PAYMENTS_CHANGE_CYCLE: 'autoatendimento_alterar_ciclo_pagamento',
      CATEGORY_PAYMENTS_CHANGE_PLAN: 'autoatendimento_alterar_plano_hospedagem',
      CATEGORY_PAYMENTS_CHANGE_METHOD: 'autoatendimento_alterar_metodo_pagamento',
      CATEGORY_PAYMENTS_REACTIVATE: 'autoatendimento_reativar_plano',
      CATEGORY_PAYMENTS_CANCEL_SUB: 'autoatendimento_cancelar_assinatura',
    },
  },
  NEW_TICKET: {
    CAMPAIGN: 'Novo Ticket',
    ACTION: {
      NEW_TICKET: 'Clique no botão "Novo chamado"',
    },
    LABEL: {
      NEW_TICKET: 'clique_botao_novo_chamado_listagem',
    },
  },
};

const newSupportAnalytics = (group, key) => {
  const data = {
    tracker: {
      campaign: EVENT[group].CAMPAIGN,
      action: EVENT[group].ACTION[key],
      label: EVENT[group].LABEL[key],
    },
  };
  collectTrackData(data.tracker);
};

export default { newSupportAnalytics };
